var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "169px",
    height: "650px",
    viewBox: "0 0 169 650",
    style: {
      enableBackground: "new 0 0 169 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6C376;}\n\t.st1{fill:#7F9DB2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.98,303.3c-0.33,1.21-1.58,1.91-2.79,1.58c-1.21-0.33-1.92-1.58-1.58-2.79 c2.75-9.95,11.94-16.92,22.64-16.92c12.94,0,22.77,9.38,22.77,22.73c0,6.01-2.87,12.17-7.36,16.23c-1.94,1.76-5.21,3.99-9.84,6.76 c-3.43,2.05-5.52,5.74-5.52,9.73v3.46c0,1.25-1.02,2.27-2.27,2.27c-1.25,0-2.27-1.01-2.27-2.27v-3.46c0-5.59,2.94-10.76,7.73-13.63 c4.4-2.63,7.46-4.72,9.12-6.23c3.56-3.22,5.86-8.17,5.86-12.87c0-10.8-7.76-18.2-18.24-18.2C75.58,289.7,68.18,295.32,65.98,303.3z "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.04,364.5c-2.5,0-4.53-2.03-4.53-4.54c0-2.51,2.03-4.54,4.53-4.54c2.5,0,4.53,2.03,4.53,4.54 C86.57,362.46,84.54,364.5,82.04,364.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169,324.5c0-46.09-37.1-83.66-83-84.46V0h-3v240.04c-45.9,0.81-83,38.37-83,84.46c0,46.09,37.1,83.66,83,84.46 V650h3V408.96C131.9,408.16,169,370.59,169,324.5z M84.5,406C39.56,406,3,369.44,3,324.5S39.56,243,84.5,243s81.5,36.56,81.5,81.5 S129.44,406,84.5,406z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionImage);
export default __webpack_public_path__ + "static/media/questionImage.66732b5260bf687ca4f2a9deb88785d8.svg";
export { ForwardRef as ReactComponent };